import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { SkeletonComponent } from '@syncfusion/ej2-react-notifications'
import './MarketingSkeleton.css'

type MarketingSkeletonAnimationProps = {
  hideHeader?: boolean
}

const MarketingSkeletonAnimation: React.FC<MarketingSkeletonAnimationProps> = ({
  hideHeader = false,
}) => {
  const skeletonConfigs = {
    headerLeftButtons: [
      { width: '84px', height: '32px', shimmerEffect: 'Fade' },
      { width: '64px', height: '32px', shimmerEffect: 'Fade' },
      { width: '48px', height: '32px', shimmerEffect: 'Fade' },
      { width: '48px', height: '32px', shimmerEffect: 'Fade' },
    ],
    columnOneSkeletons: [
      { width: '60%', height: '20px', shimmerEffect: 'Pulse' },
      { width: '80%', height: '20px', shimmerEffect: 'Pulse' },
    ],
    innerButtons: [
      { width: '100px', height: '20px', shimmerEffect: 'Fade' },
      { width: '100px', height: '20px', shimmerEffect: 'Fade' },
    ],
  }

  const renderSkeletons = (
    configs: { width: string; height: string; shimmerEffect: string }[],
    keyPrefix: string,
  ): React.ReactElement[] =>
    configs.map((config, index) => (
      <SkeletonComponent
        key={`${keyPrefix}-${index}`}
        shape="Rectangle"
        {...config}
      />
    ))

  return (
    <Container
      fluid
      className={`skeleton-loading${hideHeader ? ' skeleton-loading--tab' : ''}`}
    >
      {!hideHeader && (
        <Row>
          <Col>
            <div className="marketing-skeleton-header">
              <div className="marketing-skeleton-header-left">
                <div className="mshli-button-group">
                  {renderSkeletons(
                    skeletonConfigs.headerLeftButtons,
                    'header-left-button',
                  )}
                </div>
              </div>
              <div className="marketing-skeleton-header-right">
                <SkeletonComponent
                  shape="Rectangle"
                  width="139px"
                  height="30px"
                  shimmerEffect="Fade"
                />
              </div>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <div className="marketing-skeleton-header-title">
            <SkeletonComponent
              shape="Rectangle"
              width="150px"
              height="16px"
              shimmerEffect="Fade"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="marketing-skeleton-body">
            <div className="centered-skeleton-box-buttons">
              <SkeletonComponent
                shape="Rectangle"
                width="200px"
                height="16px"
                shimmerEffect="Fade"
              />
              <div className="centered-flex-container">
                <SkeletonComponent
                  shape="Rectangle"
                  width="140px"
                  height="30px"
                  shimmerEffect="Fade"
                />
                <SkeletonComponent
                  shape="Rectangle"
                  width="120px"
                  height="30px"
                  shimmerEffect="Fade"
                />
              </div>
            </div>
            <Row>
              <Col md={8}>
                <div className="ms-body-two-column-one">
                  <SkeletonComponent
                    shape="Rectangle"
                    width="60%"
                    height="16px"
                    shimmerEffect="Fade"
                  />
                  <div className="ms-body-two-column-one-box">
                    {renderSkeletons(
                      skeletonConfigs.columnOneSkeletons,
                      'column-one-skeleton',
                    )}
                    <div className="ms-body-two-column-one-box-inner-buttons">
                      {[...Array(2)].map((_, index) => (
                        <div key={`inner-button-group-${index}`}>
                          {renderSkeletons(
                            skeletonConfigs.innerButtons,
                            `inner-button-${index}`,
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="ms-body-two-column-two">
                  <SkeletonComponent
                    shape="Rectangle"
                    width="60%"
                    height="16px"
                    shimmerEffect="Wave"
                  />
                  <SkeletonComponent
                    shape="Rectangle"
                    width="100%"
                    height="540px"
                    shimmerEffect="Fade"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default MarketingSkeletonAnimation
